export default __webpack_public_path__ + "static/media/Reset_Icon.256.eb58ea50.png";